import React, { useState, useMemo } from 'react';
import { Button, Input } from '@material-tailwind/react';

const UserAssignment = ({
  assignedUsers,
  availableUsers,
  handleAddUser,
  handleRemoveUser
}) => {
  const [localSearchAvailable, setLocalSearchAvailable] = useState('');
  const [localSearchAssigned, setLocalSearchAssigned] = useState('');

  const filteredAvailableUsers = useMemo(() => {
    const searchLower = localSearchAvailable.toLowerCase();
    return availableUsers.filter(user => 
      `${user.first_name} ${user.last_name}`.toLowerCase().includes(searchLower) ||
      user.email.toLowerCase().includes(searchLower)
    );
  }, [availableUsers, localSearchAvailable]);

  const filteredAssignedUsers = useMemo(() => {
    const searchLower = localSearchAssigned.toLowerCase();
    return assignedUsers.filter(user => 
      `${user.first_name} ${user.last_name}`.toLowerCase().includes(searchLower) ||
      user.email.toLowerCase().includes(searchLower)
    );
  }, [assignedUsers, localSearchAssigned]);

  const handleAddAll = () => {
    const allIds = filteredAvailableUsers.map(u => u.id);
    if(allIds.length > 0) handleAddUser(allIds);
  };

  const handleRemoveAll = () => {
    const allIds = filteredAssignedUsers.map(u => u.id);
    if(allIds.length > 0) handleRemoveUser(allIds);
  };

  return (
    <div className="mt-8">
      <h2 className="text-2xl font-bold mb-6">Gestión de Usuarios</h2>
      
      <div className="flex gap-4 mb-6">
        <Button
          onClick={handleAddAll}
          disabled={filteredAvailableUsers.length === 0}
          className="bg-green-500 hover:bg-green-600 px-4 py-2 text-sm"
        >
          Agregar Todos ({filteredAvailableUsers.length})
        </Button>
        <Button
          onClick={handleRemoveAll}
          disabled={filteredAssignedUsers.length === 0}
          className="bg-red-500 hover:bg-red-600 px-4 py-2 text-sm"
        >
          Quitar Todos ({filteredAssignedUsers.length})
        </Button>
      </div>

      <div className="flex gap-6 flex-col md:flex-row">
        <div className="flex-1 border rounded-lg shadow-sm p-4">
          <div className="mb-4">
            <h3 className="text-lg font-semibold mb-2 text-green-600">
              Usuarios Disponibles
            </h3>
            <Input
              type="text"
              placeholder="Buscar por nombre o email..."
              value={localSearchAvailable}
              onChange={(e) => setLocalSearchAvailable(e.target.value)}
              className="!border !border-gray-300 focus:!border-green-500"
              labelProps={{ className: 'hidden' }}
            />
          </div>
          <div className="h-96 overflow-y-auto space-y-2">
            {filteredAvailableUsers.map((user) => (
              <div
                key={user.id}
                className="flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
              >
                <div>
                  <p className="font-medium">
                    {user.first_name} {user.last_name}
                  </p>
                  <p className="text-sm text-gray-600">{user.email}</p>
                </div>
                <Button
                  onClick={() => handleAddUser(user.id)}
                  size="sm"
                  className="bg-green-500 hover:bg-green-600 px-4 py-2"
                >
                  Agregar →
                </Button>
              </div>
            ))}
            {filteredAvailableUsers.length === 0 && (
              <p className="text-gray-500 text-center py-4">
                {localSearchAvailable ? 'No hay resultados' : 'No hay usuarios disponibles'}
              </p>
            )}
          </div>
        </div>

        <div className="flex-1 border rounded-lg shadow-sm p-4">
          <div className="mb-4">
            <h3 className="text-lg font-semibold mb-2 text-blue-600">
              Usuarios en el Grupo
            </h3>
            <Input
              type="text"
              placeholder="Buscar miembros..."
              value={localSearchAssigned}
              onChange={(e) => setLocalSearchAssigned(e.target.value)}
              className="!border !border-gray-300 focus:!border-blue-500"
              labelProps={{ className: 'hidden' }}
            />
          </div>
          <div className="h-96 overflow-y-auto space-y-2">
            {filteredAssignedUsers.map((user) => (
              <div
                key={user.id}
                className="flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
              >
                <div>
                  <p className="font-medium">
                    {user.first_name} {user.last_name}
                  </p>
                  <p className="text-sm text-gray-600">{user.email}</p>
                </div>
                <Button
                  onClick={() => handleRemoveUser(user.id)}
                  size="sm"
                  className="bg-red-500 hover:bg-red-600 px-4 py-2"
                >
                  ← Quitar
                </Button>
              </div>
            ))}
            {filteredAssignedUsers.length === 0 && (
              <p className="text-gray-500 text-center py-4">
                {localSearchAssigned ? 'No hay resultados' : 'No hay usuarios asignados'}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserAssignment;